import React from "react";

import background from '@cover/hamsternstoppen/background-1.jpg';
import backgroundSm from '@cover/hamsternstoppen/background-1-sm.jpg';
import HamsternStoppen from "../components/cover/animations/hamsternstoppen";

export const meta = {
	category: "stop",
	slug: "hamstern",
	id: "HamsternStoppen",
	name: "hamsternstoppen",
	title: "Ausverkauft",
	excerpt: {
		before: "Das gefühlte (Un)Wort des Jahres 2020",
	},
	animation: HamsternStoppen,
	cover: {
		background: {
			lg: background,
			sm: backgroundSm
		},
		alt: "Eine Art Wasserfall bildet sich aus Toilettenpapier-Rollen, auf denen ängstliche Gesichter zu sehen sind. Hamster sitzen auf Ihnen und ihren Bahnen."
	}
}

const HamsternstoppenArticle = () => {
	return (
		<div>
			<p className="articleStatement articleStatement--large">
				hams_tern, [ˈhamstɐn],
			</p>
			<p className="articleParagraph">
				schwaches Verb; Perfektbildung mit „hat“
				<br/>
				<br/>
				1 a Hamsterkäufe vornehmen
				<br/>
				1 b (angesichts einer drohenden Knappheit) horten
				<br/>
				2 a (besonders bei Bauern auf dem Land) etwas gegen Lebensmittel eintauschen
			</p>
		</div>
	)
};

export default HamsternstoppenArticle;